var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1283 4236 c-700 -281 -1273 -513 -1273 -516 0 -8 2533 -1020 2552 -1020 9 0 445 172 970 381 524 210 961 384 971 386 16 5 17 -33 17 -708 l0 -714 -58 -30 c-117 -60 -207 -181 -232 -313 -36 -183 56 -378 226 -478 18 -11 13 -29 -100 -370 -65 -197 -119 -364 -120 -372 -1 -10 40 -29 129 -58 71 -24 134 -44 140 -44 6 0 44 101 85 225 41 124 77 225 80 225 3 0 39 -101 80 -225 41 -124 79 -225 85 -225 6 0 69 20 140 44 89 29 130 48 129 58 -1 8 -55 175 -120 372 -113 341 -118 359 -100 370 170 100 262 295 226 478 -25 132 -115 253 -232 313 l-58 30 0 776 0 776 145 59 c80 33 145 61 145 64 0 4 -2528 1022 -2549 1026 -3 1 -579 -228 -1278 -510z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 2697 c0 -119 5 -240 11 -269 26 -126 119 -262 248 -360 89 -68 302 -170 431 -206 235 -67 381 -86 660 -86 279 0 425 19 660 86 129 36 342 138 431 206 129 98 222 234 248 360 16 78 15 486 -1 479 -7 -2 -311 -125 -675 -271 l-663 -267 -662 267 c-365 146 -669 269 -675 271 -10 4 -13 -42 -13 -210z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.dbee2d510a8b54780a8ed2f1513f61bc.svg";
export { ForwardRef as ReactComponent };